<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" @click="showModal('Add')"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-5"></div>
        <paginated-table ref="dataTable" :can-delete="true" :can-show="false" :can-edit-modal="true" v-on:editData="doEdit" :can-edit="false" :can-reject="false" :can-approve="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
        <b-modal ref="my-modal" centered hide-footer :title="type + ' Vehicle Category'">
            <form v-on:submit.prevent="doSubmit">
                <label>Name *</label>
                <b-form-input :required="true" for-input="name" type="text" name="name" id="name" label="Name" placeholder="Enter name" v-validate="modelValidations.name" :error="errors.first('name')" v-model="model.name" data-vv-as="name"/><br>
                <label>Note *</label>
                <b-form-input :required="true" for-input="note" type="text" name="note" id="note" label="Note" placeholder="Enter note" v-validate="modelValidations.note" :error="errors.first('note')" v-model="model.note" data-vv-as="note"/><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            </form>
        </b-modal>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'vehicle-category',
        components: {
            PaginatedTable
        },
        data () {
            return {
                dataKey: 'vehicleCategory',
                apiUrl: window.AppConfig.apiUrl + 'vehicle-category',
                type: null,
                columns: [
                    {
                        key: 'name',
                        sortable: true
                    }, {
                        key: 'note',
                        sortable: true
                    }, {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
                model: {
                    uuid: null,
                    name: null,
                    note: null
                },
                fakeModel: {
                    isRequired: null
                },
                modelValidations: {
                    name: {
                        required: true
                    },
                    note: {
                        required: true
                    }
                }
            }
        },
        methods: {
            doEdit (row) {
                this.type = row.type
                this.setData(row)
                this.$refs['my-modal'].show()
            },
            setData (row) {
                this.model.uuid = row.uuid
                this.model.name = row.name
                this.model.note = row.note
            },
            resetData () {
                this.model.uuid = null
                this.model.name = null
                this.model.note = null
                this.$validator.reset()
            },
            doSubmit () {
                    this.$validator.validateAll().then(res => {
                    if (res) {
                        this.isLoading = true
                        if (this.model.uuid !== null) {
                        let model = {}
                        Object.keys(this.model).forEach(element => {
                            if (element !== 'uuid') {
                            model[element] = this.model[element]
                            }
                        })
                            this.$http.patch(this.apiUrl + '/' + this.model.uuid, model).then(response => {
                                this.isLoading = false
                                this.$store.dispatch('notification/success', 'Vehicle Category successfully updated.')
                                this.$refs.dataTable.getDataTable()
                                this.resetData()
                                this.hideModal()
                            }).catch(error => {
                                this.isLoading = false
                                this.$store.dispatch('notification/error', error)
                            })
                        } else {
                            this.$http.post(this.apiUrl, this.model).then(response => {
                                this.isLoading = false
                                this.$store.dispatch('notification/success', 'Vehicle Category successfully added.')
                                this.hideModal()
                                this.resetData()
                                this.$refs.dataTable.getDataTable()
                            }).catch(error => {
                                this.isLoading = false
                                this.$store.dispatch('notification/error', error)
                            })
                        }
                    }
                })
            },
            showModal(type) {
                this.model.name = null
                this.model.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.type = type
                this.$refs['my-modal'].show()
            },
            hideModal () {
                this.resetData()
                this.$refs['my-modal'].hide()
            }
        }
    }
</script>